import { gql } from "@apollo/client";

export const CREATE_EXPENSE_TYPE = gql`
  mutation CreateExpenseType($input: ExpenseTypeInput) {
    createExpenseType(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_ALL_EXPENSE_TYPE = gql`
  query GetAllExpenseType {
    getAllExpenseType {
      _id
      engType
      khType
      remark
    }
  }
`;

export const UPDATE_EXPENSE_TYPE = gql`
  mutation UpdateExpenseType($id: ID!, $input: ExpenseTypeInput) {
    updateExpenseType(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_EXPENSE_TYPE = gql`
  mutation DeleteExpenseType($id: ID!) {
    deleteExpenseType(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_EXPENSE = gql`
  mutation CreateExpense($input: ExpenseInput) {
    createExpense(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_EXPENSE_PAGINATION = gql`
  query GetExpensePagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $type: String
    $fromDate: String
    $toDate: String
  ) {
    getExpensePagination(
      page: $page
      limit: $limit
      pagination: $pagination
      type: $type
      fromDate: $fromDate
      toDate: $toDate
    ) {
      data {
        _id
        type {
          _id
          engType
          khType
          remark
        }
        date
        exchangeRate
        amountUSD
        amountKHR
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_EXPENSE = gql`
  mutation UpdateExpense($id: ID!, $input: ExpenseInput) {
    updateExpense(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_EXPENSE = gql`
  mutation DeleteExpense($id: ID!) {
    deleteExpense(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
